/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TruckUtilizationCharDataPoint } from './TruckUtilizationCharDataPoint';
import {
    TruckUtilizationCharDataPointFromJSON,
    TruckUtilizationCharDataPointFromJSONTyped,
    TruckUtilizationCharDataPointToJSON,
    TruckUtilizationCharDataPointToJSONTyped,
} from './TruckUtilizationCharDataPoint';

/**
 * 
 * @export
 * @interface DashboardFleetStatusData
 */
export interface DashboardFleetStatusData {
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    driveTime: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    driveTimeTrend?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    operatorsLoggedIn: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    operatorsLoggedInTrend?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    expiredOperatorLicenses: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    expiringOperatorLicenses: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    expiringTruckLeases: number;
    /**
     * 
     * @type {Array<TruckUtilizationCharDataPoint>}
     * @memberof DashboardFleetStatusData
     */
    truckUtilizationChartData: Array<TruckUtilizationCharDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    activeTrucks: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    inMaintenanceTrucks: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    maintenanceOverdueTrucks: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardFleetStatusData
     */
    maintenanceDueTrucks: number;
}

/**
 * Check if a given object implements the DashboardFleetStatusData interface.
 */
export function instanceOfDashboardFleetStatusData(value: object): value is DashboardFleetStatusData {
    if (!('driveTime' in value) || value['driveTime'] === undefined) return false;
    if (!('operatorsLoggedIn' in value) || value['operatorsLoggedIn'] === undefined) return false;
    if (!('expiredOperatorLicenses' in value) || value['expiredOperatorLicenses'] === undefined) return false;
    if (!('expiringOperatorLicenses' in value) || value['expiringOperatorLicenses'] === undefined) return false;
    if (!('expiringTruckLeases' in value) || value['expiringTruckLeases'] === undefined) return false;
    if (!('truckUtilizationChartData' in value) || value['truckUtilizationChartData'] === undefined) return false;
    if (!('activeTrucks' in value) || value['activeTrucks'] === undefined) return false;
    if (!('inMaintenanceTrucks' in value) || value['inMaintenanceTrucks'] === undefined) return false;
    if (!('maintenanceOverdueTrucks' in value) || value['maintenanceOverdueTrucks'] === undefined) return false;
    if (!('maintenanceDueTrucks' in value) || value['maintenanceDueTrucks'] === undefined) return false;
    return true;
}

export function DashboardFleetStatusDataFromJSON(json: any): DashboardFleetStatusData {
    return DashboardFleetStatusDataFromJSONTyped(json, false);
}

export function DashboardFleetStatusDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardFleetStatusData {
    if (json == null) {
        return json;
    }
    return {
        
        'driveTime': json['driveTime'],
        'driveTimeTrend': json['driveTimeTrend'] == null ? undefined : json['driveTimeTrend'],
        'operatorsLoggedIn': json['operatorsLoggedIn'],
        'operatorsLoggedInTrend': json['operatorsLoggedInTrend'] == null ? undefined : json['operatorsLoggedInTrend'],
        'expiredOperatorLicenses': json['expiredOperatorLicenses'],
        'expiringOperatorLicenses': json['expiringOperatorLicenses'],
        'expiringTruckLeases': json['expiringTruckLeases'],
        'truckUtilizationChartData': ((json['truckUtilizationChartData'] as Array<any>).map(TruckUtilizationCharDataPointFromJSON)),
        'activeTrucks': json['activeTrucks'],
        'inMaintenanceTrucks': json['inMaintenanceTrucks'],
        'maintenanceOverdueTrucks': json['maintenanceOverdueTrucks'],
        'maintenanceDueTrucks': json['maintenanceDueTrucks'],
    };
}

export function DashboardFleetStatusDataToJSON(json: any): DashboardFleetStatusData {
    return DashboardFleetStatusDataToJSONTyped(json, false);
}

export function DashboardFleetStatusDataToJSONTyped(value?: DashboardFleetStatusData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'driveTime': value['driveTime'],
        'driveTimeTrend': value['driveTimeTrend'],
        'operatorsLoggedIn': value['operatorsLoggedIn'],
        'operatorsLoggedInTrend': value['operatorsLoggedInTrend'],
        'expiredOperatorLicenses': value['expiredOperatorLicenses'],
        'expiringOperatorLicenses': value['expiringOperatorLicenses'],
        'expiringTruckLeases': value['expiringTruckLeases'],
        'truckUtilizationChartData': ((value['truckUtilizationChartData'] as Array<any>).map(TruckUtilizationCharDataPointToJSON)),
        'activeTrucks': value['activeTrucks'],
        'inMaintenanceTrucks': value['inMaintenanceTrucks'],
        'maintenanceOverdueTrucks': value['maintenanceOverdueTrucks'],
        'maintenanceDueTrucks': value['maintenanceDueTrucks'],
    };
}

